import script from "./GitHub.vue?vue&type=script&setup=true&lang=js"
export * from "./GitHub.vue?vue&type=script&setup=true&lang=js"

import "./GitHub.vue?vue&type=style&index=0&id=4f162739&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f162739"]])

export default __exports__